import {
    PAYMETHOD_CREDIT_CARD_ICON,
    PAYMETHOD_CREDIT_CARD_ID,
    PAYMETHOD_POINTS_ICON,
} from 'src/app/core/constants';

export interface PaymethodWizard {
    id: string /** Id del tipo de pago */;
    description: string /** Nombre del tipo de pago */;
    logo: string /** Logo del tipo de pago */;
    url: string /** TODO: Concretar que es  */;
    url_ok: string /**  Comprobaciones OK   */;
    url_err: string /**  Comprobaciones NO OK */;
    checked: boolean /** Indica si el usuario a seleccionado este servicio (lógica interna del asistente de compras UNICAMENTE) */;
    icon: string /** Indica el icono que tendrá en el listado. Solo para template flowwwer */;
}

export interface PaymethodWizardCheckedEvent {
    paymethod: PaymethodWizard;
    checkedEvent: boolean;
}

/**
 * A factory function that creates PaymethodWizard
 */
export function createPaymethodWizard(params: Partial<PaymethodWizard>) {
    return {} as PaymethodWizard;
}

/**
 * Factoría que crea una Familia para el asistente de pedir cita con los datos recogidos por la API
 */
export function paymethodWizardFactory(params: any) {
    const icon =
        params.PayMethodID === PAYMETHOD_CREDIT_CARD_ID
            ? PAYMETHOD_CREDIT_CARD_ICON
            : PAYMETHOD_POINTS_ICON;
    return {
        id: params.PayMethodID,
        description: params.PayMethodName,
        logo: params.PayMethodLogo,
        url: params.PayMethodURL,
        url_ok: params.PayMethodURL_OK,
        url_err: params.PayMethodURL_ERR,
        checked: false,
        icon: icon,
    } as PaymethodWizard;
}
